// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"bef48277","372":"cda17b26","624":"0c2ae544"}[chunkId] + ".chunk.css";
};